// extracted by mini-css-extract-plugin
export var activityContainer = "_lp-0";
export var typingIndicatorContainer = "_lp-1";
export var typingIndicatorDot = "_lp-2";
export var wave = "_lp-3";